import React, { useState } from 'react';
import { toast } from 'sonner';
import { ActionDialog, Field, inputCls, primaryBtn } from './ActionDialog';
import { authFetch } from '../MedicationExtras';

// Saves one document to the chart flagged for every certification period (e.g. signed consent, ID, advance directive)
export const AttachToAllDialog = ({ patientId, onClose }) => {
  const [file, setFile] = useState(null);
  const [desc, setDesc] = useState('');
  const [busy, setBusy] = useState(false);
  const upload = async () => {
    if (!file) { toast.error('Choose a file first'); return; }
    setBusy(true);
    try {
      const form = new FormData();
      form.append('file', file);
      form.append('description', `[All episodes] ${desc || file.name}`);
      const res = await authFetch(`/patients/${patientId}/packages`, { method: 'POST', body: form });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || `Upload failed (${res.status})`);
      toast.success('Attached to all episodes of this patient');
      onClose();
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };
  return (
    <ActionDialog title="Attach to All Episodes" onClose={onClose} testid="attach-all-dialog">
      <div className="space-y-3">
        <p className="text-sm text-gray-600">Upload a document once (consent, photo ID, advance directive, insurance card) and it is kept in the chart for every certification period.</p>
        <Field label="File (PDF or image, max 15 MB)"><input type="file" accept=".pdf,image/*,.doc,.docx" onChange={e => setFile(e.target.files?.[0] || null)} className="text-sm" data-testid="attach-all-file" /></Field>
        <Field label="Description"><input className={inputCls} value={desc} onChange={e => setDesc(e.target.value)} placeholder="e.g. Signed admission consent" data-testid="attach-all-desc" /></Field>
        <div className="flex justify-end"><button className={primaryBtn} onClick={upload} disabled={busy} data-testid="attach-all-upload">{busy ? 'Uploading…' : 'Attach'}</button></div>
      </div>
    </ActionDialog>
  );
};
